import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import { motion } from "framer-motion";

import socket from './../socket.js'


function VerifyCode() {




const [error,setError]=useState("");

const [code,setCode] = useState ("");
const navigate = useNavigate ();
const location = useLocation ();
const phone = location.state.phone;
useEffect (()=>{
  if (!socket)return;

//    socket.on ('message',(data)=>{
//      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
//      if (data.event==='code_send') window.alert(data.data);
//    });
  socket.on ('message',(data)=>{
    const da=JSON.parse(data);
    if (da.verify==true)
    {
      if (da.units!=null && da.token!=null)
      {
          localStorage.setItem('token',da.token);
          localStorage.setItem('phone', phone);
          localStorage.setItem('units', JSON.stringify(da.units));
          localStorage.setItem('select_unit', '0');


          navigate ("/");


  //      saveData (data);

        }
      }else {
        window.alert ('کد وارد شده اشتباه است')
        navigate ("/PhoneNumber");
      }
  })



return () =>{
  socket.off ('message');
};

},[socket]);

const verify =()=>{


// فعلاً تستی
// بعداً از سرور جواب می‌گیریم
if (code.length==6)
//      socket.emit ('myCode',{"code":code});
  socket.emit ('myCode',{"phone":phone,"code":code})
else
  window.alert ('کد وارد شده اشتباه است')


};



return (

<div className="
min-h-screen
bg-slate-950
flex
items-center
justify-center
px-5
">


<motion.div

initial={{scale:.8,opacity:0}}

animate={{scale:1,opacity:1}}

className="
bg-slate-900
border
border-slate-700
rounded-3xl
p-10
w-full
max-w-md
text-center
"


>


<h1 className="
text-3xl
font-bold
text-cyan-400
mb-6
">

تایید شماره

</h1>



<p className="
text-gray-400
mb-8
">

کد ارسال شده به

<br/>

<span className="text-white">
{phone}
</span>

را وارد کنید

</p>




<input

maxLength="6"

value={code}

onChange={(e)=>setCode(e.target.value)}

placeholder="------"

className="
w-full
bg-slate-800
border
border-slate-600
rounded-xl
p-4
text-center
tracking-[10px]
text-2xl
text-white
outline-none
focus:border-cyan-400
"


/>



{
error &&

<p className="
text-red-400
mt-4
">

{error}

</p>

}



<button

onClick={verify}

className="
mt-8
w-full
bg-green-500
py-4
rounded-xl
hover:bg-green-600
transition
"

>

تایید و ورود

</button>


</motion.div>


</div>

);


}


export default VerifyCode;
